import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';

import LogoGobierno from 'static/img/gobierno_color_transparente_white.png';
import LogoInstituto from 'static/img/logo_igear.png';

import './Header.css';

declare var CONFIGURATIONS;

class Header extends Component {
  render() {
    return (<Fragment>
      <header className='h-desktop'>
        <div className="logo-gobierno">
          <img src={LogoGobierno} alt='Logo del gobierno'/>
        </div>
        <div className='visor-title'>
          <label className='title'>Fototeca Digital de Aragón</label>
        </div>
        <div className="logo-instituto">
          <img src={LogoInstituto} alt='Logo del gobierno'/>
        </div>
      </header>
    </Fragment>);
  }
}

export default translate()(Header);
